export default __webpack_public_path__ + "static/media/OurGamer2.7ed0f409.png";